import { render } from "./SettingsModal.vue?vue&type=template&id=e3828986&scoped=true"
import script from "./SettingsModal.vue?vue&type=script&lang=ts"
export * from "./SettingsModal.vue?vue&type=script&lang=ts"

import "./SettingsModal.vue?vue&type=style&index=0&id=e3828986&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e3828986"

export default script